'use client'

import dynamic from 'next/dynamic'

const InsiderBasketSync = dynamic(
  () =>
    import('@/components/analytics/insider-basket-sync').then(
      (m) => m.InsiderBasketSync
    ),
  { ssr: false }
)

const InsiderTracker = dynamic(
  () =>
    import('@/components/analytics/insider-tracker').then(
      (m) => m.InsiderTracker
    ),
  { ssr: false }
)

export function InsiderClient() {
  return (
    <>
      <InsiderBasketSync />
      <InsiderTracker />
    </>
  )
}
